"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }, theme.breakpoints.down('sm'), {
      flexWrap: 'wrap'
    }),
    label: _defineProperty({
      flexBasis: theme.spacing(11),
      flexGrow: 0,
      flexShrink: 0,
      color: theme.palette.text.secondary,
      margin: [[0, theme.spacing(2), 0, 0]],
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily,
      whiteSpace: 'nowrap'
    }, theme.breakpoints.down('sm'), {
      flexBasis: '100%',
      margin: 0
    })
  };
};

var _default = (0, _withStyles["default"])(styles);

exports["default"] = _default;